module.exports = __webpack_public_path__ + "static/media/westbury-kitchen.6c581e84.jpeg";